// extracted by mini-css-extract-plugin
export default {"item":"AddonItem_item__DwkOo","row":"AddonItem_row__vo+bJ","credits":"AddonItem_credits__lx+E9","price":"AddonItem_price__TOf3s"};